/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from './Company'
import type { Professional } from './Professional'
import type { Talentpool } from './Talentpool'
import type { Users_Permissions_User } from './Users_Permissions_User'
import type { Vacancy } from './Vacancy'
export type Referral = {
  id?: number
  recipient?: string
  type?: Referral.type
  referredToTalentpool?: Talentpool
  referredToCompany?: Company
  referredToVacancy?: Vacancy
  companySender?: Company
  status?: Referral.status
  code?: string
  locked?: boolean
  referredProfessional?: Professional
  professionalSender?: Professional
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Referral {
  export enum type {
    COMPANY_INVITE = 'companyInvite',
    TALENTPOOL_INVITE = 'talentpoolInvite',
    VACANCY_INVITE = 'vacancyInvite',
    PROFESSIONAL_PUBLIC = 'professionalPublic',
    COMPANY_PUBLIC = 'companyPublic',
    VACANCY_PUBLIC = 'vacancyPublic',
  }
  export enum status {
    INVITED = 'invited',
    ACCOUNT_ALREADY_CREATED = 'accountAlreadyCreated',
    ACCOUNT_CREATED = 'accountCreated',
  }
}
